// Vuex -> pinia Migration guide : https://pinia.vuejs.org/cookbook/migration-vuex.html#Restructuring-Modules-to-Stores
import Vue from 'vue';
import { createPinia, PiniaVuePlugin } from 'pinia'
const pinia = createPinia();
Vue.use(PiniaVuePlugin);

export default pinia;

